/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.directives {
    export interface IBaseFormScope extends ng.IScope {
        formConfiguration: Wars.Domain.Model.Form;
        isConfigureMode: boolean;
        showSlider: boolean;
        moveStepAvailable: boolean;
        process: models.ProcessDto;
        processConfigurationId: string;
        formDataId: string;
        parentFormId: string;
        model: BaseFormModel;
        processConfiguration: Wars.Domain.Model.ProcessConfiguration;
    }
}

module warsApp.directives {

    export abstract class BaseForm implements IDirective {
        public link($scope: any, element: JQuery, attrs: ng.IAttributes) {

        }

        public controllerAs = 'controller';
        public restrict: string = 'E';
        public scope: any = {
            process: "=",
            processConfigurationId: "=",
            isConfigureMode: "=",
            formConfiguration: "=",
            formDataId: "=",
            parentFormId: "=",
            processConfiguration: "="
        };
    }

    export abstract class BaseFormModel {
        public formData: any;
        //public form: any;
        public isReadOnly: boolean;
        public isConfigureMode: boolean;
        public showSlider: boolean;
        public isStepAvailable: boolean;
        public currentStep: Wars.Domain.Model.FormStep;
        public formConfiguration: Wars.Domain.Model.Form;
        public currentStepIndex: number;
        public isFieldChangedProcessAction: boolean;
        protected previousSaveJson: string;
        protected customStepFunctions: any;
        public fields: Wars.Domain.Model.Field[];
        public moveStepAvailable: boolean;
        public showHtml: boolean;
        public showJavascript = false;
        public showPreview = false;
        public isEditMode = true;
        public showCustomCode = false;
        public editor: AceAjax.Editor;
        public selectedFunction: Wars.Domain.Model.FormCodeFunction;
        public apiActions: Wars.Domain.Model.ApiAction[];
        public filteredApiActions: Wars.Domain.Model.ApiAction[];
        public processTypes: Wars.Domain.Model.ProcessType[];
        public selectedApiAction: Wars.Domain.Model.ApiAction;

        constructor(
            protected angularLoader: services.AngularLoadService,
            protected formSectionService: services.FormSectionService,
            protected modalService: any,
            protected $http: angular.IHttpService,
            protected dataSourceService: services.DataSourceService,
            protected formService: services.FormService,
            public process: warsApp.models.ProcessDto,
            protected formDataService: services.FormDataService,
            protected growl: angular.growl.IGrowlService,
            protected formCodeFunctionService: Services.FormCodeFunctionService,
            private customDivService: services.CustomDivService,
            protected manageProcessDataConfigurationService: services.ManageProcessDataConfigurationService,
            private apiConfigurationService: services.ApiActionService,
            protected securityMatrixService: services.SecurityMatrixService,
            protected deleteService:services.DeleteService,
            private scope: angular.IScope,
            public formDataId?: string) {

        }

        protected abstract setupImplementedForm();

        public setupForm() {
            this.setupImplementedForm();

            if (this.process && this.formDataId) {
                this.setFormData();
                this.setReadOnly();
            }
        }

        protected setReadOnly() {
            var visibility: Wars.Domain.Model.Dtos.FormVisibility =
                this.process.formsVisibilities[this.formConfiguration.uniqueIdentifier];

            if (visibility.formVisiblility === Wars.Domain.Model.Codes.Enums.SecurityItemValue.Updateable ||
                visibility.formVisiblility === Wars.Domain.Model.Codes.Enums.SecurityItemValue.Show) {
                this.isReadOnly = false;
                //console.log("Set Readonly");
            } else {
                this.isReadOnly = true;
                //console.log("Set Readonly");
            }
        }

        protected setFormData() {
            if (this.formConfiguration.formType === Wars.Domain.Model.Codes.Enums.FormType.Manage &&
                !Enumerable.from(this.formConfiguration.myManageSections).any(m => m.manageSectionType ===
                    Wars.Domain.Model.Codes.Enums.ManageSectionType.EmbeddedForm))
                return;

            if (!this.formDataId)
                return;

            let formUniqueId = this.parentFormId ? this.parentFormId : this.formConfiguration.uniqueIdentifier;
            let self = this;
            if (this.process &&
                this.process.formJson &&
                (Object.keys(this.process.formJson).length > 0 || Object.keys(this.process.formJson).length > 0) &&
                this.formConfiguration.uniqueIdentifier &&
                this.formDataId) {
                if (this.formDataId) {

                    if (this.process.formJson[formUniqueId] && this.process.formJson[formUniqueId][this.formDataId]) {
                        this.formData = this.process.formJson[formUniqueId][this.formDataId];
                        return;
                    } else {
                        this.formData = {};
                    }
                } else {
                    this.formData = {};
                }
            } else {
                this.formData = {};
                if (!this.process) {
                    return;
                }
            }

            if (!this.process.formJson[formUniqueId]) {
                this.process.formJson[formUniqueId] = {};
            }

            this.process.formJson[formUniqueId][this.formDataId] = this.formData;
        }

        public setupProcess() {
            if (this.formConfiguration && this.formDataId) {
                this.setFormData();
            }
        }

        private runFunctions(loadFunctions) {
            loadFunctions.forEach(f => {
                let args = ['processId', 'formId', 'formDataId', f.javascript];
                let myFunc = Function.apply(null, args);

                myFunc(this.process.id, this.formConfiguration.id, this.formDataId);
            });
        }

        protected loadStepJavascript() {
            if (!this.process || !this.process.customStepFunctions)
                return;

/*            this.formConfiguration.urlDependencies.forEach(url => {
                if (url.type == Wars.Domain.Model.Codes.Enums.UrlDependencyType.Javascript) {
                    this.angularLoader.loadScript(url.url);
                } else {
                    this.angularLoader.loadCSS(url.url);
                }
            });*/

            var functions: Wars.Domain.Model.Dtos.CustomFunctionDto[] =
                this.process.customStepFunctions[this.currentStep.id];

            if (functions) {
                var loadFunctions = Enumerable.from(functions)
                    .where(f => f.customCodeType === Wars.Domain.Model.Codes.Enums.CustomCodeType.Load)
                    .toArray();

                let customDivCount = Enumerable.from(this.currentStep.formSections)
                    .selectMany(f => f.fields)
                    .where(f => f.type === Wars.Domain.Model.Codes.Enums.FieldType.CustomDiv)
                    .count();

                if (customDivCount > 0) {
                    this.customDivService.registerDivLoadedHandler(this.currentStep.id,
                        (count) => {
                            if (count >= customDivCount) {
                                this.customDivService.unregisterDivLoadedHandler(this.currentStep.id);
                                this.customDivService.resetCounter();
                                this.runFunctions(loadFunctions);
                            }
                        });
                } else {
                    this.runFunctions(loadFunctions);
                }
            }
            //if (this.currentStep.isCustomStep) {
            //    this.currentStep.urlDependencies.forEach(url => {
            //        if (url.type == Wars.Domain.Model.Codes.Enums.UrlDependencyType.Javascript) {
            //            this.angularLoader.loadScript(url.url);
            //        } else {
            //            this.angularLoader.loadCSS(url.url);
            //        }
            //    });

            //    if (!this.customStepFunctions[this.currentStep.id]) {
            //        var functionStr = "(" + this.currentStep.javascript + ")";
            //        this.customStepFunctions[this.currentStep.id] = eval(functionStr)();
            //    }
            //    //TODO: This is a hack fix after the demo
            //    setTimeout(() => this.customStepFunctions[this.currentStep.id].stepLoaded(this.formConfiguration, () => { }, this.isReadOnly), 1599);
            //}
        }

        public loadFieldsConditions() {
            this.fields = [];
            if (!this.process || !this.currentStep.formSections)
                return;

            if (this.currentStep.formSections) {
                for (var i = 0; i < this.currentStep.formSections.length; i++) {
                    var formSection = this.currentStep.formSections[i];

                    if (formSection.objectSchema.isList && !this.process.id) {
                        if (!this.formData) {
                            this.formData = {};
                        }

                        this.formData[formSection.objectSchema.uniqueIdentifier] = [];
                    }

                    if (formSection.fields) {
                        for (var x = 0; x < formSection.fields.length; x++) {
                            if (formSection.fields[x].condition_id == null)
                                continue;

                            this.fields.push(formSection.fields[x]);
                        }
                    }
                }
            }
        }

        public fieldBlurred(model: any) {

        }

        public save(callback?: any) {
            if (this.isConfigureMode) {
                this.formService.saveAllChanges(callback);
            }
        }

        protected loadStepUrls() {
            this.currentStep.entityAspect.loadNavigationProperty("urlDependencies");
        }

        public setupFormSchema() {
            this.formService.setupFormSchema(this.formConfiguration);
        }

        public addGroup() {
            var formSection: warsApp.models.FormSection = this.formService.createFormSection(this.currentStep);
            formSection.position = this.currentStep.formSections.length + 1;
            formSection.formSectionDisplayType = Wars.Domain.Model.Codes.Enums.FormSectionDisplayType.Panel;
            formSection.formSectionType = Wars.Domain.Model.Codes.Enums.FormSectionType.Standard;

            formSection.securityMatrix = this.securityMatrixService.createSecurityMatrix(false, true);
            formSection.objectSchema = this.dataSourceService.createNewObjectSchema();

            formSection.objectSchema.name = "Group Heading";
            formSection.objectSchema.uniqueIdentifier = services.UtilityService.generateGuidComb();
            formSection.isVisible = true;

            var self = this;

            this.modalService.showModal({
                templateUrl: "./app/views/modals/addGroup.html",
                controller: "addFormSectionController",
                size: 'lg',
                inputs: {
                    formSection: formSection,
                    form: self.formConfiguration
                }
            }).then(modal => {
                modal.element.modal();

                modal.close.then(result => {
                    $('.modal-backdrop').each(function() {
                        $(this).remove();
                    });

                    if (result) {
                        if (formSection.formSectionType === Wars.Domain.Model.Codes.Enums.FormSectionType.List) {
                            formSection.objectSchema.isList = true;
                        }

                        this.currentStep.formSections.push(formSection);

                        this.setGroupParentObjectSchema(formSection);
                        self.save();
                    } else {
                        self.formService.rejectChanges();
                    }
                });
            });

        }


        public htmlSelected() {
            this.showHtml = true;
            this.showJavascript = false;
            this.showPreview = false;
        }

        public javascriptSelected() {
            this.showHtml = false;
            this.showJavascript = true;
            this.showPreview = false;
        }

        public previewSelected() {
            this.showHtml = false;
            this.showJavascript = false;
            this.showPreview = true;

        }

        protected setGroupParentObjectSchema(formSection: Wars.Domain.Model.FormSection) {
            /*let newProp = this.dataSourceService.createNewSchemaProperty();
            newProp.name = formSection.objectSchema.name;
            newProp.typeSchema = formSection.objectSchema;
            newProp.propertyType = formSection.objectSchema.isList
                ? Wars.Domain.Model.Codes.Enums.VariableType.List
                : Wars.Domain.Model.Codes.Enums.VariableType.Object;
*/
                //this.currentStep.objectSchema.properties.push(newProp);
                //newProp.parentObjectSchema = this.currentStep.objectSchema;
            this.formService.setupFormSchema(this.formConfiguration);

            this.save(() => {
                //formSection.objectSchema.parentProperty = newProp;
                this.save();
            });
        }


        public formSectionSort($item: Wars.Domain.Model.FormSection,
            $partFrom: Wars.Domain.Model.FormSection[],
            $partTo,
            $indexFrom,
            $indexTo,
            $modal) {
            var arrayCopy = Enumerable.from($partFrom).orderBy(z => z.position).toArray();

            var spliced = arrayCopy.splice($indexFrom, 1);
            arrayCopy.splice($indexTo, 0, spliced[0]);

            $item.position = $indexTo;

            for (var i = 0; i < $partFrom.length; i++) {
                var numberId = $partFrom[i].id;
                $partFrom[i].position = Enumerable.from(arrayCopy).indexOf(i => i.id == numberId);
            }

            this.save();
        }

        public manageSectionSort($item: Wars.Domain.Model.ManageSection,
            $partFrom: Wars.Domain.Model.ManageSection[],
            $partTo,
            $indexFrom,
            $indexTo,
            $modal) {

            var aaaa = 0;

            var arrayCopy = Enumerable.from($partFrom).orderBy(z => z.position).toArray();

            var spliced = arrayCopy.splice($indexFrom, 1);
            arrayCopy.splice($indexTo, 0, spliced[0]);

            $item.position = $indexTo;

            for (var i = 0; i < $partFrom.length; i++) {
                var numberId = $partFrom[i].id;
                $partFrom[i].position = Enumerable.from(arrayCopy).indexOf(i => i.id == numberId);
            }

            this.save();
        }

        public parentFormId: string;
    }

    export class BaseFormController implements IController {
        constructor(
            protected scope: IBaseFormScope) {
            var self = this;

            self.scope.model.formConfiguration = self.scope.formConfiguration;
            self.scope.model.isConfigureMode = self.scope.isConfigureMode;
            self.scope.model.formDataId = self.scope.formDataId;
            self.scope.model.parentFormId = self.scope.parentFormId;


            this.scope.$watch('formConfiguration',
                (newvalue, oldValue) => {
                    self.scope.model.formConfiguration = self.scope.formConfiguration;
                    if (self.scope.formConfiguration) {
                        self.scope.model.setupForm();
                    }
                });

            this.scope.$watch('process',
                (newvalue, oldValue) => {
                    if (newvalue == oldValue)
                        return;

                    self.scope.model.process = self.scope.process;
                    if (self.scope.process) {
                        self.scope.model.isFieldChangedProcessAction = (self.scope.process as any).isFieldChangedProcessAction;
                        self.scope.model.setupProcess();
                        self.scope.model.setupForm();
                    }
                });

            this.scope.$watch('formDataId',
                () => {
                    self.scope.model.formDataId = self.scope.formDataId;
                    self.scope.model.setupProcess();
                });
        }
    }
}